import { Stack, Typography } from '@mui/material';
import { fmtBaths, fmtSize } from './format';
import { border, text } from '../../theme/colors';

/**
 * The strip directly under the price: the handful of numbers a buyer compares
 * between listings. Each fact is a value with a quiet label beneath it, and any
 * fact the realtor did not enter simply does not appear — a blank "— bath" is
 * worse than no bath count at all.
 */
export default function KeyFacts({ listing }) {
  const l = listing || {};
  const isHouse = l.listing_type === 'house';
  const facts = [];

  if (isHouse && l.bedrooms != null) facts.push({ value: String(l.bedrooms), label: 'bed' });
  if (isHouse && l.bathrooms != null) facts.push({ value: fmtBaths(l.bathrooms), label: 'bath' });
  if (isHouse && l.floor_area_sqm != null) facts.push({ value: fmtSize(l.floor_area_sqm), label: 'floor' });
  if (l.stand_size_sqm != null) facts.push({ value: fmtSize(l.stand_size_sqm), label: 'stand' });
  if (l.year_built != null) facts.push({ value: String(l.year_built), label: 'built' });
  if (l.parking) facts.push({ value: l.parking, label: 'parking' });

  if (facts.length === 0) return null;

  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      useFlexGap
      spacing={0}
      sx={{ rowGap: 1.5, columnGap: 3, py: 1.5, borderTop: `1px solid ${border.light}`, borderBottom: `1px solid ${border.light}` }}
    >
      {facts.map((f) => (
        <Stack key={f.label} spacing={0}>
          <Typography variant="subtitle1" sx={{ fontWeight: 800, color: text.primary, lineHeight: 1.25 }}>
            {f.value}
          </Typography>
          <Typography variant="caption" sx={{ color: text.tertiary }}>{f.label}</Typography>
        </Stack>
      ))}
    </Stack>
  );
}
